export const AUTHENTICATE = '@@Auth/Authenticate';
export const USER_AUTHENTICATED = '@@Auth/UserAuthenticated';